export enum SkeletonLoaderType {
  LINE,
  AVATAR,
}
